module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon4.a5cb0ad8.svg";